// eslint-disable-next-line no-unused-vars
import React from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"
import { useStaticQuery, graphql } from "gatsby"
import Container from "../layout/container"
import Content from "../../content/about-us/nos-valeurs.json"
import { colors } from "../../utils/theme/colors"
import Img from "gatsby-image"

const Paragraph = ({ text }) => (
  <p
    sx={{
      fontSize: `0.94rem`,
      color: colors.code.secondary,
      textAlign: `left`,
    }}
  >
    {text}
  </p>
)

const NosValeursText = ({ langKey }) => {
  const data = useStaticQuery(graphql`
    query NosValeursTextQuery {
      People: file(relativePath: { eq: "NosValeursDesktopPic.png" }) {
        childImageSharp {
          # Other options include height (set both width and height to crop),
          # grayscale, duotone, rotate, etc.
          fixed(width: 700, height: 500) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)

  const { paragraph1, paragraph2 } = Content[langKey]

  return (
    <Container>
      <div
        sx={{
          display: `flex`,
          width: `100%`,
          justifyContent: `space-between`,
          zIndex: 0,
        }}
      >
        <div sx={{ display: [`none`, `none`, `flex`, `flex`] }}>
          <Img fixed={data.People.childImageSharp.fixed} alt="people" />
        </div>
        <div
          sx={{
            display: `flex`,
            flexDirection: `column`,
            width: [`100%`, `100%`, `40%`, `40%`],
            pt: `3rem`,
            pl: `3rem`,
          }}
        >
          <Paragraph text={paragraph1} />
          <Paragraph text={paragraph2} />
        </div>
      </div>
    </Container>
  )
}

export default NosValeursText
